// Register ranges are inclusive Sydney calendar days, independent of the browser zone.
export function noteCalendarDay(value) {
  if (!value) return "";
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const parsed = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(parsed.getTime()) &&
      parsed.toISOString().slice(0, 10) === value
      ? value
      : "";
  }
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-AU", {
    timeZone: "Australia/Sydney",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const part = (type) => parts.find((item) => item.type === type).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}
export function noteMatchesDate(value, range, now = new Date()) {
  if (range === "All") return true;
  const day = noteCalendarDay(value),
    today = noteCalendarDay(now);
  if (!day || !today || day > today) return false;
  if (range === "Today") return day === today;
  if (range === "Last 30 days") {
    const first = new Date(
      new Date(`${today}T00:00:00Z`).getTime() - 29 * 86400000
    )
      .toISOString()
      .slice(0, 10);
    return day >= first;
  }
  if (range === "This financial year") {
    const year = Number(today.slice(0, 4)) - (today.slice(5, 7) < "07" ? 1 : 0);
    return day >= `${year}-07-01`;
  }
  return true;
}
